/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import React from 'react';

import { System } from '@/components/icons';

interface ErrorBoundaryProps {
  errorMessage: string;
  customErrorMessage: string | undefined;
  className: string | undefined;
}

export const ErrorBoundaryMessage = ({
  errorMessage,
  customErrorMessage,
  className,
}: ErrorBoundaryProps) => {
  if (!customErrorMessage || !errorMessage) return null;

  return (
    <div
      className={`${className} my-auto flex flex-col items-center justify-center`}
    >
      {/* icons goes here */}
      {System.InfoIcon('w-[38.25px] h-[38.25px] text-[#40565A]')}
      <p className="pt-2 text-body-lg text-white">{customErrorMessage}</p>
      <div className="px mt-4 max-w-[500px] rounded-sm px-4 py-3">
        {/* Display error message */}
        <p className="text-form-input-text text-form-input-disabled">
          Error: {errorMessage}
        </p>
      </div>
    </div>
  );
};
